import { render } from "./circle-btn.vue?vue&type=template&id=038e341c&scoped=true"
import script from "./circle-btn.vue?vue&type=script&lang=js"
export * from "./circle-btn.vue?vue&type=script&lang=js"

import "./circle-btn.vue?vue&type=style&index=0&id=038e341c&lang=scss&scoped=true"

import exportComponent from "/var/www/birchplace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038e341c"]])

export default __exports__